import * as STD from '@emersya/mpa-std';
import * as CM from '@emersya/mpa-components-manager';

interface IDropdownData {
};

export class DropdownRenderingMode extends CM.Plugin.PluginWithData<
	InputSelectComponent<any, any>,
	IDropdownData
> implements TInputSelectRenderingMode<any, any> {
	id = 'dropdown';
	currentlyOpen: InputSelectComponent<any, any> | null = null;

	private open(component: InputSelectComponent<any, any>) {
		component.component_DOM.classList.add('opened');
		this.currentlyOpen = component;
	};

	private close() {
		if (!this.currentlyOpen) {
			throw STD.errors.user('Close called but there are non currently opened dropdown!', {});
		}
		this.currentlyOpen.component_DOM.classList.remove('opened');
		this.currentlyOpen = null;
	};

	onWindowKeyboard(event: KeyboardEvent) {
		if (!this.currentlyOpen) {
			return;
		}
		const key = event.key.toLowerCase();
		const wantedOption = (<CM.DOMComponent<any, any, any>[]>this.currentlyOpen.component_outerChilds).find(x => x.component_DOM?.textContent[0].toLowerCase() ===
			key);
		if (wantedOption) {
			wantedOption.component_DOM.scrollIntoView({smooth: true});
		}
	};

	onBoxClick(component: InputSelectComponent<any, any>, ev: Event) {
		if (this.currentlyOpen !== component) {
			this.open(component);
		} else {
			this.close();
		}
		ev.stopImmediatePropagation();
	};

	generateData() {
		return ({});
	};

	getSlotDOM(component: InputSelectComponent<any, any>) {
		const childs = Array.from(component.component_DOM.children);
		return (<any>childs.find(x => x.classList.contains('selector')));
	};

	onWindowClick() {
		if (this.currentlyOpen) {
			this.close();
		}
	};

	private onValueUpdated(ev: STD.events.BoundEvent<InputSelectComponent<any, any>, CM.Component<any, any>>) {
		const component = <InputSelectComponent<any, any>>ev.target;
		const selected = ev.details.newValue;
		const selectablesPlaceholder = <HTMLDivElement>component.component_DOM.querySelector('.selectablesPlaceholder');
		const selectablesContainer = (<HTMLDivElement>selectablesPlaceholder.parentElement);
		if (ev.details.oldValue) {
			selectablesContainer.insertBefore(ev.details.oldValue.component_DOM, selectablesPlaceholder);
		}
		if (selected) {
			selectablesContainer.insertBefore(selectablesPlaceholder, selected.component_DOM);
			(<HTMLDivElement>component.component_DOM.querySelector('.box')).appendChild(selected.component_DOM);
		}
	};

	override attach(component: InputSelectComponent<any, any>) {
		super.attach(component);
		component.component_DOM.dataset.renderingMode = this.id;
		component.component_DOM.append(...[
			{
				classList: ['box'],
				events: {
					click: this.onBoxClick.bind(this, component)
				}
			}, {
				classList: ['selector'],
				childs: [
					{
						classList: ['selectablesPlaceholder']
					}
				]
			}
		].map(x => STD.DOM.factory(x)));
		component.addEventListener('value', this.onValueUpdated.bind(this), {
			isAtTarget: true,
			listener: component,
			subType: (<typeof InputSelectComponent<any, any>>component.static).getInputEventSubType()
		});
	};

	override detach(component: InputSelectComponent<any, any>) {
		super.detach(component);
		const childs = Array.from(component.component_DOM.children);
		(<any>childs.find(x => x.classList.contains('box'))).remove();
		(<any>childs.find(x => x.classList.contains('selector'))).remove();
	};

	constructor() {
		super();
		document.addEventListener('click', this.onWindowClick.bind(this));
		document.addEventListener('keypress', this.onWindowKeyboard.bind(this));
	};
};
import {InputSelectComponent, TInputSelectRenderingMode} from '../InputSelect';
import './Dropdown.scss';
